var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CandidatesOrder } from "@sequentech/ui-core";
import { EditBase, useUpdate } from "react-admin";
import { ContestDataForm } from "./EditContestDataForm";
export var EditContestData = function () {
    var update = useUpdate()[0];
    function updateCandidatesOrder(data) {
        var _a;
        (_a = data.candidatesOrder) === null || _a === void 0 ? void 0 : _a.map(function (candidate, index) {
            var contestPresentation = data.presentation;
            if ((contestPresentation === null || contestPresentation === void 0 ? void 0 : contestPresentation.candidates_order) === CandidatesOrder.CUSTOM) {
                var candidatePresentation = candidate.presentation;
                return update("sequent_backend_candidate", {
                    id: candidate.id,
                    data: {
                        presentation: __assign(__assign({}, candidatePresentation), { sort_order: index }),
                    },
                    previousData: candidate,
                });
            }
            return null;
        });
    }
    var transform = function (data) {
        var _a, _b, _c, _d, _e, _f, _g;
        // update candidates
        updateCandidatesOrder(data);
        delete data.candidatesOrder;
        var presentation = data === null || data === void 0 ? void 0 : data.presentation;
        var i18n = (_a = presentation === null || presentation === void 0 ? void 0 : presentation.i18n) !== null && _a !== void 0 ? _a : {};
        // name, alias and description fields
        var fromPresentationName = ((_b = i18n === null || i18n === void 0 ? void 0 : i18n.en) === null || _b === void 0 ? void 0 : _b.name) || ((_c = i18n[Object.keys(i18n)[0]]) === null || _c === void 0 ? void 0 : _c.name) || "";
        data.name = fromPresentationName;
        var fromPresentationAlias = ((_d = i18n === null || i18n === void 0 ? void 0 : i18n.en) === null || _d === void 0 ? void 0 : _d.alias) || ((_e = i18n[Object.keys(i18n)[0]]) === null || _e === void 0 ? void 0 : _e.alias) || "";
        data.alias = fromPresentationAlias;
        var fromPresentationDescription = ((_f = i18n === null || i18n === void 0 ? void 0 : i18n.en) === null || _f === void 0 ? void 0 : _f.description) || ((_g = i18n[Object.keys(i18n)[0]]) === null || _g === void 0 ? void 0 : _g.description) || "";
        data.description = fromPresentationDescription;
        // END name, alias and description fields
        return data;
    };
    return (_jsx(EditBase, __assign({ redirect: ".", transform: transform }, { children: _jsx(ContestDataForm, {}) })));
};
